module.exports = __webpack_public_path__ + "img/thumbnail-asnee-video.e834154.jpg";